import { collection, getDocs, query, where } from "firebase/firestore";
import { firestore } from "../../services/firebase/index";

export const getProducts = () => {
    const productsCollection = collection(firestore, 'products');
    const q = query(productsCollection, where("marketplace", "in", ["Guru Digital", "PAGARME"]));
    return getDocs(q);
}